import { CatalogoFilters } from '../type/filter'

function isEnumLikeFacet(facet: unknown): facet is { type: string; values: unknown[] } {
  if (!facet || typeof facet !== 'object') return false
  const f = facet as { type?: string; values?: unknown }
  return (
    (f.type === 'enum' || f.type === 'boolean') && Array.isArray(f.values)
  )
}

/**
 * Quan un filtre enum es restringeix, l'API pot tornar menys opcions.
 * Mantenim les opcions prèvies amb count=0 per estabilitat interna; la UI
 * només mostra count > 0 (o l’opció ja seleccionada).
 * Només s'aplica si les opcions noves són un subconjunt de les anteriors.
 */
export function mergeFacetOptionsWithPrevious(
  prev: CatalogoFilters | null | undefined,
  next: CatalogoFilters
): CatalogoFilters {
  if (!prev) return next

  const merged: CatalogoFilters = { ...next }

  for (const key of Object.keys(next)) {
    const nextFacet = next[key]
    const prevFacet = prev[key]

    if (!isEnumLikeFacet(nextFacet) || !isEnumLikeFacet(prevFacet)) continue
    if (prevFacet.values.length <= nextFacet.values.length) continue

    const nextIds = new Set(nextFacet.values.map((v) => String((v as { id: unknown }).id)))
    const prevIds = prevFacet.values.map((v) => String((v as { id: unknown }).id))
    const isSubset = [...nextIds].every((id) => prevIds.includes(id))

    if (!isSubset) continue

    const nextById = new Map(
      nextFacet.values.map((v) => [String((v as { id: unknown }).id), v])
    )

    const mergedValues = prevFacet.values.map((prevVal) => {
      const id = String((prevVal as { id: unknown }).id)
      const nextVal = nextById.get(id)
      if (nextVal) return nextVal
      return { ...(prevVal as object), count: 0 }
    })

    merged[key] = {
      ...(nextFacet as object),
      values: mergedValues,
    } as CatalogoFilters[string]
  }

  return merged
}
